import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { SharedModule } from '../../shared/modules/shared.module';
import { AuthkitService } from '../../services/authKit.service';
import { NgIf } from '@angular/common';
import { LoadingComponent } from '../loading/loading.component';
import { isEmail } from '../../utils/email.util';
import { PAGE_ROUTES } from '../../constants';
import { PopupType } from '../login-by-user-password/login-by-user-password.component';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-migrated-user-prompt',
  imports: [SharedModule, TranslatePipe, NgIf, LoadingComponent],
  standalone: true,
  templateUrl: './migrated-user-prompt.component.html',
  styleUrl: './migrated-user-prompt.component.scss'
})
export class MigratedUserPromptComponent implements OnChanges {
  @Input() title = '';
  @Input() loginHint = '';
  @Input() promptContent = '';
  @Input() type?: PopupType = undefined;
  @Input() goPreStep?: () => void;

  protected isLoading = false;
  protected mailToLink = '';

  get loginHintHtml() {
    return `<b class="highlight">${this.loginHint}</b>`;
  }

  constructor(
    private _authKitService: AuthkitService,
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    const type = changes['type'].currentValue

    this.mailToLink = type === PopupType.uMWE ? `mailto:${environment.supportEmail}` : PAGE_ROUTES.FOTGOT_PASSWORD
  }

  async handleNext() {
    this.isLoading = true;
    await this._authKitService.init({ redirectUri: window.location.origin });
    await this._authKitService.signIn({ loginHint: isEmail(this.loginHint) ? this.loginHint : undefined });
  }

  handleTryAgain() {
    if (typeof this.goPreStep === 'function') this.goPreStep();
  }

  handleContactUs = () => {
    window.location.href = this.mailToLink;
  };

  getButtonLabel() {
    switch (this.type) {
      case PopupType.uM:
        return 'button.Next'

      default:
        return 'button.Try again'
    }
  }

  handleClick() {
    switch (this.type) {
      case PopupType.uM:
        this.handleNext()
        break;

      default:
        this.handleTryAgain()
        break;
    }
  }
}
